export default "__VITE_ASSET__BU3kr0Ex__";